import React, {h, Component} from 'preact';
import {PropTypes} from 'preact-compat';
import './AlsoSellingModal.scss';

export default class AlsoSellingModal extends Component {
    static get propTypes() {
        return {
            userId: PropTypes.number,
            requestId: PropTypes.number,
            phone: PropTypes.string,
            onModalClose: PropTypes.func
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            addressInvalid: false
        };
    }

    componentDidMount() {
        this.focusAddressInput();
        if (this.address) {
            const autocomplete = new google.maps.places.Autocomplete(this.address, {
                types: ['address'],
                componentRestrictions: {country: 'us'}
            });
            autocomplete.setFields(['address_components', 'geometry']);
        }
    }

    focusAddressInput = () => {
        if (this.address) {
            this.address.focus();
            trackEvent('Proposal', 'alsoSellingBuyerClickedIntoAddressFieldOnPopUp1').withGA().withOptimizely();
        }
    };

    handleSubmit = e => {
        e.preventDefault();
        let addressValue = this.address.value;
        let addressComponents = addressValue.split(',');
        if (addressComponents.length < 3) {
            this.setState({addressInvalid: true});
            return;
        }
        let address = addressComponents[0].trim();
        let city = addressComponents[1].trim();
        let state = addressComponents[2].trim();
        let location = city + ', ' + state;

        const params = {
            location: location,
            'prop.address': address,
            'prop.homeType': 'Single Family'
        };
        this.setState({isLoading: true});
        $.post('api/validateDirectSubmit-json', params).then(data => {
            if (!checkAjax(data)) {
                this.setState({isLoading: false});
                return;
            }
            $.post('updateBuyRequestAccount-json', {
                requestId: this.props.requestId,
                sellingAlso: true
            }).then(response => {
                this.setState({isLoading: false});
                if (!checkAjax(response)) {
                    return;
                }
                logEvent({
                    event: 'ALSO_SELLING_ANSWERED',
                    comment: global.userName + ' Is also selling: Yes',
                    realtorId: null,
                    requestId: this.props.requestId,
                    isBuyer: true,
                    onlyOnce: false,
                    attributes: {
                        LOCATION: location,
                        ADDRESS: address,
                        CITY: city,
                        STATE: state,
                    }
                });
                this.props.onModalClose();
                let modal = React.createElement(reactComponents.Proposal.ThankYouForLettingUsKnowModal, {
                    userId: this.props.userId,
                    phone: this.props.phone,
                    requestId: this.props.requestId
                });
                let $modal = showReactModal(modal);
                $modal.on('hidden.bs.modal', function() {
                    window.location.reload();
                });
            });
        });
    };

    render() {
        const {isLoading} = this.state;
        return (
            <div className="modal nu-modal selling-also-confirmation-modal fade" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="modal-title">
                                <div className="mt-2x-sm mb-4x text-center">
                                    <img src={global.imageBaseUrl + 'proposal/cart_squircle_blue.svg'} alt='Cart icon'/>
                                </div>
                                <h4 className="text-center text-bold">Great! What’s the Address for the Property <br/> you are selling?</h4>
                                <button type="button" className="close button-close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={this.handleSubmit} className='selling-also-form'>
                                <label htmlFor="txt-selling-also-address" className="sr-only">Selling address</label>
                                <input
                                    id="txt-selling-also-address"
                                    className='form-control txt-selling-also-address'
                                    type="text"
                                    ref={ref => (this.address = ref)}
                                    placeholder='Enter the address you are selling'
                                    onClick={() => {
                                        trackEvent('Proposal', 'alsoSellingBuyerClickedIntoAddressFieldOnPopUp1')
                                            .withGA().withOptimizely();
                                    }}
                                />
                                {this.state.addressInvalid && (
                                    <label htmlFor="txt-selling-also-address" className="error">
                                        Please enter a valid full address, e.g. 1 Main St, Los Angeles, CA
                                    </label>
                                )}
                                <button
                                    onClick={() => {
                                        trackEvent('Proposal', 'alsoSellingBuyerClickedSubmitOnPopUp1')
                                            .withGA().withOptimizely();
                                    }}
                                    className='btn btn-default btn-selling-also-address'
                                    type="submit"
                                >
                                    Submit
                                </button>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-gray-outline" data-dismiss="modal">
                                Close
                            </button>
                        </div>
                        {isLoading && (
                            <div className="loadingSpinner" style="display: block; margin: 0">
                                <img src={global.imageBaseUrl + 'spinner.gif'} alt={'Loading spinner'}/>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}
